// extracted by mini-css-extract-plugin
export default {"global":"layout_global__e9WKl","container":"layout_container__76NxH","rotate":"layout_rotate__47xNG"};